var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 消息通知页 "),_c('el-empty',{attrs:{"image-size":200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }